import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthToken } from '@api/models';
import { Oauth2Service } from '@api/services';
import { TokenService } from '@api/services/authorization/token.service';
import { SmartyCubeStorageKeys } from '@core/config/smartycube-storage-keys';
import { Urls } from '@core/config/urls';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorageService, SessionStorageService, StorageKeys } from '@smartera/core';
import { UtilityService } from './utility.service';

// DEPRECATED
@Injectable()
export class LoginDialogService {
	constructor(
		private http: HttpClient,
		private tokenService: TokenService,
		private localStorageService: LocalStorageService,
		private sessionStorageService: SessionStorageService,
		private oauth2Service: Oauth2Service,
		private router: Router,
		private util: UtilityService
	) {}

	public sendRefrechTokenRequest() {
		const ref = this.sessionStorageService.getItem(StorageKeys.REFRESH_TOKEN);
		this.http
			.post(
				`${Urls.BASE_URL}/oauth/token?grant_type=refresh_token&scope=read&client_id=admin-server&refresh_token=${ref}`,
				''
			)
			.subscribe(
				(authToken: AuthToken) => {
					this.sessionStorageService.setItem(StorageKeys.LOGGED_ORG, authToken.orgId);
					this.sessionStorageService.setItem(StorageKeys.ACCESS_TOKEN, authToken.access_token);
					this.sessionStorageService.setItem(StorageKeys.REFRESH_TOKEN, authToken.refresh_token);
				},
				(err) => {
					this.tokenService.isTokenExpired.next(true);
				}
			);
	}

	public getLoginInfo(email: string, password: string, cb?) {
		return this.oauth2Service
			.login(email, password)
			.pipe(
				catchError((e) => {
					const err: string = e.error.code;
					if (err === 'login.renew.password.exception') {
						// redirect to expire password page
						this.router.navigate(['login/expire-password', email]);
					}
					return observableThrowError(err);
				})
			)
			.subscribe(() => this.tokenService.isTokenExpired.next(false));
	}

	public logout() {
		this.localStorageService.clearAll();
		this.sessionStorageService.clearAll();
		this.router.navigateByUrl('/login');
	}

	public autoLogin(token: AuthToken) {
		this.oauth2Service.storeAuthentication(token);
	}
}
